<template>
  <div>

    <h1 class="tit mb-3 mt-6">Premium y pago</h1>

    <div v-if="!loading">

      <!------------------------------>
      <!-- Información de suscripción -->
      <!------------------------------>
      <div
        v-if="plan && isPlanOnDate()"
        class="py-6 align-end"
      >
        <!------------------------------>
        <!-- Plan activo              -->
        <!------------------------------>
        <div v-if="Object.keys(plan).includes('cancel_at_period_end') && !plan.cancel_at_period_end">
          <v-card
            style="height: fit-content"
            width="100%"
            max-width="700"
            class="d-flex flex-column rounded-xl shadow-sm justify-center align-center text-center pa-10">


            <div class="d-flex align-center">
              <v-avatar color="primary">
                <v-icon size="23" color="white">{{ mdiCheck() }}</v-icon>
              </v-avatar>
              <div class="d-flex flex-column ml-3">
                <span class="font-weight-bold font-rubik"
                      style="font-size: 24px; letter-spacing: -1px; color: #256EFF"
                >
                  SeleAI
                </span>
                <div
                  style="margin-top: -6px; width: fit-content"

                >
                <span
                  style="width: fit-content; font-size: 12px"
                  class="font-weight-medium orange font-rubik white--text pa-1 rounded">Premium</span>
                </div>
              </div>
            </div>


            <div 
            class="py-10">
            <div v-if="plan.type === 'M'">
              <span 
              class="font-rubik font-weight-medium" v-if="plan.active && !plan.cancelled">
                Tu suscripción se renovará automáticamente el {{ formatDate(plan.current_period_end) }}
                <br>
                y cada mes te cobraremos {{ plan.amount }} €
              </span>

              <span 
              class="font-rubik font-weight-medium" v-else-if="plan.active && plan.cancelled">
                Has cancelado tu suscripción Premium
                <br>
                Aún tienes acceso hasta el {{ formatDate(plan.current_period_end) }}
              </span>

              <span 
              class="font-rubik font-weight-medium" v-else>
                Tu suscripción termina el {{ formatDate(plan.current_period_end) }}
              </span>
              
              </div>

              <div v-else-if="plan.type === 'S'">
                <span 
                class="font-rubik font-weight-medium" v-if="plan.active && !plan.cancelled">
                  Tu suscripción se renovará automáticamente el {{ formatDate(plan.current_period_end) }}
                  <br>
                  y cada semana te cobraremos {{ plan.amount }} €
                </span>

                <span 
                class="font-rubik font-weight-medium" v-else-if="plan.active && plan.cancelled">
                  Has cancelado tu suscripción Premium
                  <br>
                  Aún tienes acceso hasta el {{ formatDate(plan.current_period_end) }}
                </span>

                <span 
                class="font-rubik font-weight-medium" v-else>
                  Tu suscripción termina el {{ formatDate(plan.current_period_end) }}
                </span>
              </div>

              <span class="font-rubik font-weight-medium" v-else-if="plan.type === 'U'">
                Tu suscripción Premium termina el {{ formatDate(plan.current_period_end) }}
                <br>
                (Pago único - No se renueva automáticamente)
              </span>
            </div>


            <v-btn
              v-if="(plan.type === 'M' || plan.type === 'S') && plan.active && !plan.cancelled"
              @click="cancelDialog=true"
              width="fit-content"
              depressed
              class="mx-auto text-none font-rubik px-10"
            >Cancelar
            </v-btn>

          </v-card>

          <v-dialog v-model="cancelDialog"
                    max-width="700"
          >
            <v-card class="d-flex flex-column justify-center align-center text-center pa-10">

              <span
                style="font-size: 30px"
                class="font-weight-medium font-rubik">Cancelar premium</span>

              <span class="mt-2 mb-10">¿Estás seguro de que quieres cancelar tu suscripción premium?</span>

              <div class="d-flex">
                <v-btn
                  @click="cancelPlan"
                  width="fit-content"
                  depressed
                  class="mx-auto text-none font-rubik px-10"
                >
                  Sí, Cancelar
                </v-btn>
                <v-btn
                  @click="cancelDialog=false"
                  width="fit-content"
                  depressed outlined
                  class="mx-auto text-none font-rubik px-10 ml-3"
                >
                  No, Volver
                </v-btn>
              </div>
            </v-card>
          </v-dialog>

          <!-- Diálogo de error -->
          <v-dialog v-model="errorDialog"
                    max-width="600"
          >
            <v-card class="d-flex flex-column justify-center align-center text-center pa-10">

              <v-avatar color="error" class="mb-4">
                <v-icon size="23" color="white">{{ mdiAlert() }}</v-icon>
              </v-avatar>

              <span
                style="font-size: 24px"
                class="font-weight-medium font-rubik mb-4">Error al cancelar</span>

              <span class="mb-6">
                Ha ocurrido un error al intentar cancelar tu suscripción. 
                <br><br>
                Por favor, ponte en contacto con nosotros en:
                <br>
                <strong>hola@sele.es</strong>
              </span>

              <v-btn
                @click="errorDialog=false"
                width="fit-content"
                depressed
                color="primary"
                class="mx-auto text-none font-rubik px-10"
              >
                Entendido
              </v-btn>
            </v-card>
          </v-dialog>
        </div>


        <!------------------------------>
        <!-- Plan cancelado           -->
        <!------------------------------>
        <div v-if="plan.cancel_at_period_end || plan.cancelled || !plan.active"
             class="d-flex flex-wrap justify-center mt-12"
        >

          <v-card
          v-if="Object.keys(plan).includes('cancel_at_period_end') && (plan.type === 'M' || plan.type === 'S')"
            style="max-width: fit-content; height: fit-content"
            class="d-flex flex-column rounded-xl shadow-sm">

            <div class="px-8 py-6">
            <span
              class="font-rubik font-weight-medium"
              style="font-size: 20px"
            >
              Estado de la suscripción:
            </span>
            </div>

            <v-divider></v-divider>


            <div class="pa-8">
              <v-alert class="font-weight-medium font-rubik mb-6 rounded-lg"
                       type="warning"
                       border="left"
                       max-width="600"
                       :icon="mdiAlert()"
              >
                Has cancelado la suscripción Premium.
              </v-alert>

              <span class="font-rubik font-weight-medium"
              >
              Tu suscripción terminará el {{ formatDate(plan.current_period_end) }}.
            </span>
            </div>
          </v-card>

          <!-- REACTIVAR PLAN --->
          <v-card
            min-width="350"
            class="rounded-xl shadow-sm mt-10">
            <div class="px-8 py-6">
              <span
                class="font-rubik font-weight-medium"
                style="font-size: 20px"
              >
                Si quieres reactivar <br>la suscripción:
              </span>
            </div>

            <v-divider></v-divider>
            
            <pricing-section :is-start-plan="false"></pricing-section>

          </v-card>
        </div>

      </div>


      <!----------------------------->
      <!-- Sin plan                -->
      <!----------------------------->
      <div v-else class="d-flex flex-column justify-center">
        <v-alert>No tienes el plan Premium activado.</v-alert>
        <!-- REACTIVAR PLAN --->
        <v-card
          class="mt-10 rounded-xl shadow-sm mx-auto">
          <div class="px-8 py-6">
              <span
                class="font-rubik font-weight-medium"
                style="font-size: 20px"
              >
                Aprovecha al máximo tu estudio
              </span>
          </div>

          <v-divider></v-divider>
       

          <pricing-section :is-start-plan="false"></pricing-section>


        </v-card>
      </div>
    </div>
  </div>
</template>

<script>

import {mdiAlert, mdiCheck} from "/src/assets/mdi.json";
import Abonaments from "../../premium/components/Abonaments.vue";
import PricingSection from '@/components/pricing/PricingSection.vue'

export default {
  name: "PremiumConfig",
  components: {Abonaments, PricingSection},
  async mounted() {
    await this.fetchPremiumPlan()
  },
  data() {
    return {
      plan: null,
      loading: true,
      cancelDialog: false,
      errorDialog: false,
    }
  },
  computed: {
    user() {
      return this.$root.currentUser.value
    }
  },
  methods: {
    isPlanOnDate() {
      if (!this.plan || !this.plan.current_period_end) {
        return false;
      }
      
      const endDate = new Date(this.plan.current_period_end);
      const now = new Date();
      
      return endDate > now;
    },
    formatDate(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleDateString();
    },
    mdiCheck() {
      return mdiCheck
    },
    mdiAlert() {
      return mdiAlert
    },
    async fetchPremiumPlan() {
      this.loading = true;
      const {data} = await this.axios.post('/premium/plan', {
        user_id: this.$root.currentUser.userId
      })

      this.plan = data;
      this.loading = false;
    },
    async cancelPlan() {
      try {
        const {data} = await this.axios.post('/premium/del', {
          user_id: this.$root.currentUser.userId
        })

        if (data.success) {
          this.cancelDialog = false;
          await this.fetchPremiumPlan()
        } else {
          this.cancelDialog = false;
          this.errorDialog = true;
        }

      } catch (error) {
        this.cancelDialog = false;
        this.errorDialog = true;
      }
    }
  }
}
</script>

<style scoped>

</style>
